import "jQuery";
import {breakpoints} from './responsive';

'use strict';

(function($) {

    function setColumns($wrap, $elmts) {
        $('.column', $wrap).remove();
        let columns = 1;
        if(breakpoints.is('bp_min_lg')) {
            columns = $wrap.hasClass('js-columns-3') ? 3 : 2;
        } else if(breakpoints.is('bp_min_md')) {
            columns = 2;
        }
        let nb_per_col = Math.ceil($elmts.length / columns);
        let columns_array = [];
        for(let i = 0; i < columns; i++) {
            let $elmts_chunk = $elmts.slice(i * nb_per_col, (i+1) * nb_per_col);

            let column = $('<div class="column column-' + i +'"></div>');
            columns_array.push(column);
            $elmts_chunk.appendTo(column);
        }
        $.each(columns_array, function(i, col) {
            col.appendTo($wrap);
        });
    }

    function initColumns() {
        $('.js-columns-2, .js-columns-3').each(function() {
            let $wrap = $(this);
            let $elmts = $wrap.children();
            var doit;
            window.onresize = function(){
                clearTimeout(doit);
                doit = setTimeout(function() {
                    setColumns($wrap, $elmts);
                }, 100);
            };
            setColumns($wrap, $elmts);

        });
    }

    $(document).ready(function() {
        breakpoints.init();
        initColumns();
    });
})( jQuery );